var _path, _polygon, _polygon2, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8AntiguaAndBarbuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M24,44c0,0-19.666-24.193-19.047-26.122C7.538,9.825,15.086,4,24,4 c8.914,0,16.462,5.825,19.047,13.878C43.666,19.807,24,44,24,44z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "36,19 29.757,17.787 34.961,14.392 28.88,15.671 32.389,10.543 27.261,14.052 28.54,7.971 25.145,13.175 24,7 22.855,13.175 19.46,7.971 20.739,14.052 15.611,10.543 19.12,15.671 13.039,14.392 18.243,17.787 12,19 24,20"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "30,42 24,44 18,42 10.818,26.955 37.182,26.955"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 9,
    x: 5,
    y: 19,
    fill: "#0277bd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M4.96,17.88L24,44c-1.04,0-2.05-0.08-3.04-0.23C11.35,42.3,4,34.01,4,24 C4,21.87,4.33,19.81,4.96,17.88z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M44,24c0,10.01-7.35,18.3-16.96,19.77C26.05,43.92,25.04,44,24,44l19.04-26.12 C43.67,19.81,44,21.87,44,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8AntiguaAndBarbuda);
export default __webpack_public_path__ + "static/media/icons8-antigua-and-barbuda.320ca2275dc20f786cf6a8f7c939fab9.svg";
export { ForwardRef as ReactComponent };